"use client";
import { useSyncExternalStore } from "react";
import { isAuthTransitionPending, subscribeAuthTransition } from "@/lib/auth/transition";

export function useAuthTransition(): boolean {
  return useSyncExternalStore(subscribeAuthTransition, isAuthTransitionPending, () => false);
}
